import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { BASE_URL, OG_IMAGE } from '../utils/seo';
import { enterUp } from '../utils/animations';
import { StepsTimeline, InfrastructureCallout } from '../components/how-it-works/StepsTimeline';
import { OversightCallout } from '../components/how-it-works/OversightCallout';
import { PageCTA } from '../components/PageCTA';

export default function HowItWorks() {
    return (
        <div data-testid="how-it-works-page">
            <Helmet>
                <title>How It Works - White Glove Hiring</title>
                <meta name="description" content="Every step is deliberate. Every phase eliminates a failure point. From diagnostic consultation to annual business review - here's how the White Glove Hiring process works." />
                <meta property="og:title" content="How It Works - White Glove Hiring" />
                <meta property="og:description" content="A 9-step process from diagnostic consultation to annual business review. Every phase eliminates a failure point." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={`${BASE_URL}/how-it-works`} />
                <meta property="og:image" content={OG_IMAGE} />
                <link rel="canonical" href={`${BASE_URL}/how-it-works`} />
            </Helmet>

            <section className="bg-navy-900 hero-pattern pt-36 pb-20">
                <div className="max-w-7xl mx-auto px-6 lg:px-12">
                    <motion.div {...enterUp}>
                        <p className="text-gold-400 text-xs font-bold tracking-[0.3em] uppercase font-inter mb-4">The Process</p>
                        <h1 className="font-montserrat font-black text-4xl md:text-5xl lg:text-6xl text-white tracking-tight leading-tight max-w-4xl">
                            Every Step Is Deliberate. Every Phase Eliminates a Failure Point.
                        </h1>
                        <p className="text-gray-300 text-lg mt-5 max-w-2xl leading-relaxed">
                            Most VA hires fail because the process around them is broken. This is what a structured process looks like - from first conversation to long-term leverage.
                        </p>
                    </motion.div>
                </div>
            </section>

            <StepsTimeline />
            <InfrastructureCallout />
            <OversightCallout />

            <PageCTA
                headline="Ready to See If This Is a Fit?"
                sub="One conversation. We'll diagnose your current setup and tell you exactly what we'd recommend."
                testId="how-it-works-cta"
            />
        </div>
    );
}
